<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>{{ boxTitle }}</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-4">
								<div class="form-group">
									<label>Código</label>
									<input v-validate="'required'" name="codigo" maxlength="2" v-model="dados.codigo" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('codigo') }}</span>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Nome</label>
									<input v-validate="'required'" name="nome" v-model="dados.nome" class="form-control" type="text">
									<span class="text-danger">{{ errors.first('nome') }}</span>
								</div>
							</div>
							<div class="col-md-4">
								<div class="form-group">
									<label>Subgrupo</label>
									<select v-validate="'required'" name="subgrupo" v-model="dados.procedimento_subgrupo_id" class="form-control">
										<option value="">Selecione o subgrupo...</option>
										<option v-for="(subgrupo, index) in subgrupos" :value="subgrupo.id" :key="index">{{subgrupo.codigo}} - {{subgrupo.nome}}</option>
									</select>
									<span class="text-danger">{{ errors.first('subgrupo') }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="box-footer">
						<div class="row">
							<div class="col-md-12">
								<button @click="salvar()" class="btn btn-primary pull-right" type="button"><i class="fa fa-save"></i> Salvar</button>
								<button class="btn btn-default pull-left" @click="$router.go(-1)"> <i class="fa fa-reply"></i> Voltar</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http

	export default {
		inject: ["$validator"],
		data: () => ({
			dados: {
				nome: "",
				codigo: "",
				procedimento_subgrupo_id: ""
			},
			subgrupos: [],
			formaOrganizacaoId: "",
			boxTitle: "Nova Forma de organização"
		}),
		mounted() {
			this.formaOrganizacaoId = this.$route.params.formaOrganizacaoId;
			if (this.formaOrganizacaoId) {
				this.boxTitle = "Editar Forma de organização";
				this.getFormaOrganizacao(this.formaOrganizacaoId);
			}
			this.getSubrupos();
		},
		methods: {
			getSubrupos() {
				axios
					.get(`${this.$store.state.serverURI}/api/cadastros/subgrupos-procedimento/getAll`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.subgrupos = response.data;
					})
					.catch(error => {
						console.log(error);
					});
			},
			getFormaOrganizacao(formaOrganizacaoId) {
				axios
					.get(`${this.$store.state.serverURI}/api/cadastros/formas-organizacao-procedimento/getById/${this.formaOrganizacaoId}`,
						this.$store.getters.getHeaderAuth
					)
					.then(response => {
						this.dados = response.data;
						// this.dados.codigo = this.dados.codigo.split(".")[2];
					})
					.catch(error => {
						console.log(error);
					});
			},
			salvar() {
				this.$validator.validate().then(result => {
					if (result) {
						if (this.formaOrganizacaoId) {
							axios
								.post(
									`${this.$store.state.serverURI}/api/cadastros/formas-organizacao-procedimento/update/${this.formaOrganizacaoId}`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Forma de organização atualizada com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/formas-organizacao-procedimento/");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						} else {
							axios
								.post(
									`${this.$store.state.serverURI}/api/cadastros/formas-organizacao-procedimento/create`,
									this.dados,
									this.$store.getters.getHeaderAuth
								)
								.then(response => {
									this.$swal({
										type: "success",
										title: "Forma de organização criada com sucesso!",
										showConfirmButton: false,
										timer: 1500
									});
									this.$router.push("/cadastros/formas-organizacao-procedimento");
								})
								.catch(error => {
									var erros = error.response.data.message + " ";
									for (var erro of Object.values(error.response.data.errors)) {
										erros += erro + " \n";
									}
									this.$swal({
										type: "error",
										title: "Houve uma falha!",
										text: erros
									});
								});
						}
					}
				});
			}
		},
		watch: {},
		components: {}
	};
</script>

<style>

</style>



// WEBPACK FOOTER //
// form.vue?1eeb1030